import type { Client, RequestContext } from "../client";
import type { TelemetryConfigurationResource } from "../resources/telemetryConfigurationResource";
import { ConfigurationRepository } from "./configurationRepository";
export class TelemetryConfigurationRepository extends ConfigurationRepository<TelemetryConfigurationResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("TelemetryConfiguration", client, requestContext);
    }
    amplitudeApiKey(): Promise<string> {
        return this.client.get(this.requestContext, "~/api/telemetry/config", {});
    }
}
